import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/the-first-alliance/additional-value.png';
import _imports_1 from '@/assets/the-first-alliance/additional-value@2x.png';
import _imports_2 from '@/assets/the-first-alliance/additional-value@3x.png';
import _imports_3 from '@/assets/the-first-alliance/quasi-staking.png';
import _imports_4 from '@/assets/the-first-alliance/quasi-staking@2x.png';
import _imports_5 from '@/assets/the-first-alliance/quasi-staking@3x.png';
import _imports_6 from '@/assets/the-first-alliance/ce-fi.png';
import _imports_7 from '@/assets/the-first-alliance/ce-fi@2x.png';
import _imports_8 from '@/assets/the-first-alliance/ce-fi@3x.png';

const _withScopeId = n => (_pushScopeId("data-v-26c3e33b"), n = n(), _popScopeId(), n);

const _hoisted_1 = _imports_1 + ' 1x, ' + _imports_2 + ' 2x';

const _hoisted_2 = _imports_4 + ' 1x, ' + _imports_5 + ' 2x';

const _hoisted_3 = _imports_7 + ' 1x, ' + _imports_8 + ' 2x';

const _hoisted_4 = {
  class: "feature-wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("Features");

const _hoisted_6 = {
  class: "block"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  srcset: _hoisted_1,
  alt: "block"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_createTextVNode("Additional Value Retention Mechanism");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" In addition to InvestNFT standard features, The First Alliance guarantees a redemption value of more than 70% of the mint price, and 3% of their secondary market royalties providing better protection and flexibility for The First Alliance community. To learn more about the standard features, visit our Gitbook. ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("More");

const _hoisted_11 = {
  class: "block"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  srcset: _hoisted_2,
  alt: "block"
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_createTextVNode("Quasi Staking");

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Quasi staking is a premium function that is designed for The First Alliance. Our staking platform is non-custodial. Each holder can earn additional bonuses while still having ownership of their NFTs. To learn more about the staking process, please visit our Gitbook. ");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("More");

const _hoisted_16 = {
  class: "block"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  srcset: _hoisted_3,
  alt: "block"
}, null, -1));

const _hoisted_18 = /*#__PURE__*/_createTextVNode("CeFi Membership Upgrade");

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" The holders of The First Alliance NFT will be offered a complimentary level III status in the Bincentive loyalty program where holders can earn higher yields on the low-risk, stable income products. To learn more about the CeFi membership upgrade, please visit Bincentive website. ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("More");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_block_with_image = _resolveComponent("block-with-image");

  return _openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createElementVNode("div", _hoisted_6, [_createVNode(_component_block_with_image, {
    url: "https://investnft.gitbook.io/investnft/the-first-alliance/utilities",
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_7]),
    title: _withCtx(() => [_hoisted_8]),
    content: _withCtx(() => [_hoisted_9]),
    button: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_block_with_image, {
    url: "https://investnft.gitbook.io/investnft/the-first-alliance/utilities",
    imagePosition: "right"
  }, {
    image: _withCtx(() => [_hoisted_12]),
    title: _withCtx(() => [_hoisted_13]),
    content: _withCtx(() => [_hoisted_14]),
    button: _withCtx(() => [_hoisted_15]),
    _: 1
  })]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_block_with_image, {
    url: "https://investnft.gitbook.io/investnft/the-first-alliance/utilities",
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_17]),
    title: _withCtx(() => [_hoisted_18]),
    content: _withCtx(() => [_hoisted_19]),
    button: _withCtx(() => [_hoisted_20]),
    _: 1
  })])]);
}